import { InventoryActionTypes } from './constants';

type InventoryAction = { type: string, payload: {} | string };

export const inventoryApiResponseSuccess = (actionType: string, data: any): InventoryAction => ({
    type: InventoryActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});

export const inventoryApiResponseError = (actionType: string, error: string): InventoryAction => ({
    type: InventoryActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const inventoryGetAllInventory = (query: string): InventoryAction => ({
    type: InventoryActionTypes.READ_ALL_INVENTORY_REQUEST,
    payload: { query },
});

export const inventoryCreateInventory = (inventory: any, callback): InventoryAction => ({
    type: InventoryActionTypes.CREATE_INVENTORY_REQUEST,
    payload: { inventory, callback },
});

export const inventoryUpdateInventory = (inventoryId, inventory: any): InventoryAction => ({
    type: InventoryActionTypes.UPDATE_INVENTORY_REQUEST,
    payload: { inventoryId, inventory },
});

export const inventoryDeleteInventory = (inventoryId): InventoryAction => ({
    type: InventoryActionTypes.DELETE_INVENTORY_REQUEST,
    payload: { inventoryId },
});

export const inventoryResetInventory = (): InventoryAction => ({
    type: InventoryActionTypes.RESET_STATE,
    payload: {},
});

export const inventoryResetAllErrors = (): InventoryAction => ({
    type: InventoryActionTypes.RESET_ALL_ERRORS,
    payload: {},
});
